// @flow
import * as React from 'react';

import { FileText } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectIsFetchingOneOrder } from '@gandi/billing';
import { resetCart } from '@gandi/cart';
import { notifyDanger } from '@gandi/notifications';
import { Button } from '@gandi/reshaped';
import { useTranslator } from '@gandi/translate';

import { doCommitCart } from 'src/Overview/modules/actions';

import { useAppSelector } from 'src/hooks/useAppSelector';
import { selectIsAppWorking } from 'src/modules/app';

import { useCartSummaryContext } from '../../../context/CartSummary';

export function GenerateProformaButton({
  purchaseOrder,
}: {
  purchaseOrder?: string,
}): React.MixedElement | null {
  const dispatch = useDispatch();
  const translator = useTranslator();

  const navigate = useNavigate();

  const { orderId, setOrderId } = useCartSummaryContext();

  const { __ } = translator;

  const isAppWorking = useAppSelector(selectIsAppWorking);
  const isFetchingOrder = useAppSelector(state =>
    // $FlowFixMe[incompatible-call]
    selectIsFetchingOneOrder(state, { orderId }),
  );

  const loading = isAppWorking || isFetchingOrder;

  const handleClick: (evt: SyntheticEvent<>) => Promise<void> = async (
    evt: SyntheticEvent<>,
  ) => {
    evt.preventDefault();

    try {
      const response = await dispatch(
        doCommitCart(
          purchaseOrder ? { external_reference: purchaseOrder } : undefined,
        ),
      );
      dispatch(resetCart());
      setOrderId(response.data.session_id);
      navigate(`/awaiting-payment/${response.data.session_id}`);
    } catch (error) {
      const title =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : __('Cart checkout error');
      const message = error.errors
        ? error.errors.map(({ description }) => description)
        : __('An error occurred when committing your cart.');
      dispatch(
        notifyDanger({
          title,
          message,
        }),
      );
    }
  };

  return (
    <Button
      icon={FileText}
      size="large"
      color="primary"
      fullWidth
      loading={loading}
      onClick={handleClick}
      type="button"
    >
      {__('Generate a proforma')}
    </Button>
  );
}
